<template>
    <div>
        <JetDialogModal
            :show="modalOpen"
            ref="modal"
            @close="modalClose"
            v-if="modalOpen"
        >
            <template #title>
                <h2>Add Variable</h2>
            </template>
            <template #content>
                <form @submit.prevent="handleSubmit()" method="POST" v-if="fields">
                    <div class="py-2">
                        <label
                            class="w-full block text-gray-700"
                        >Select a Variable</label>
                        <multiselect
                            :options="fields"
                            placeholder="Select a variable"
                            v-model="selectedField"
                            label="label"
                            select-label=""
                            deselect-label=""
                        />
                    </div>
                    <div class="py-5">
                        <label
                            class="w-full block text-gray-700"
                        >Set a Fallback Value</label>
                        <jet-input
                            v-model="fallback"
                            placeholder="i.e. friend"
                            class="mb-3 w-full"
                        />
                    </div>
                </form>
            </template>

            <template #footer>
                <button class="mr-4" @click="modalClose">
                    Cancel
                </button>

                <JetSecondaryButton
                    class="px-2 py-1 text-xs"
                    type="button"
                    @click="handleSubmit"
                >Add Variable</JetSecondaryButton>
            </template>
        </JetDialogModal>

        <button
            class="text-xs sm:text-sm cursor-pointer px-4 py-2 bg-gray-100 rounded-full hover:bg-gray-300 focus:outline-none"
            type="button"
            @click.prevent="modalOpen = true"
        >{ } Add Variable</button>
    </div>
</template>
<script>
    import JetDialogModal from "../Jetstream/DialogModal";
    import JetSecondaryButton from "../Jetstream/SecondaryButton";
    import JetInput from "../Jetstream/Input";

    export default {
        emits: ['select'],
        components: {
            JetDialogModal,
            JetSecondaryButton,
            JetInput,
        },
        data() {
            return {
                modalOpen: false,
                fallback: '',
                selectedField: null,
            }
        },
        computed: {
            fieldValue() {
                if (!this.selectedField) return '';

                const defaultAttribute = this.fallback && this.fallback.length > 0 ?
                    ` default="${this.fallback}"` : '';

                return {
                    label: this.selectedField.label,
                    tag: `{ ${this.selectedField.tag}${defaultAttribute} }`,
                };
            },
            customFields() {
                return this.$page.props.custom_fields.data.flatMap(field => {

                    if (field.type == "Address") {
                        return [
                            {
                                tag: '"' + "Street Line 1" + '"',
                                label: 'Custom Field: ' + field.name + ' Street Line 1',
                            },
                            {
                                tag: '"' + "Street Line 2" + '"',
                                label: 'Custom Field: ' + field.name + ' Street Line 2',
                            },
                            {
                                tag: '"' + "City" + '"',
                                label: 'Custom Field: ' + field.name + ' City',
                            },
                            {
                                tag: '"' + "State" + '"',
                                label: 'Custom Field: ' + field.name + ' State',
                            },                                                                   
                            {
                                tag: '"' + "Postal Code" + '"',
                                label: 'Custom Field: ' + field.name + ' Postal Code',
                            },
                        ];
                    }

                    return {
                        tag: '"' + field.name + '"',
                        label: 'Custom Field: ' + field.name,
                    }
                });
            },
            fields() {
                let defaultFields = [
                    {
                        tag: 'firstName',
                        label: 'First Name',
                    },
                    {
                        tag: 'lastName',
                        label: 'Last Name',
                    }
                ];
                let fields = defaultFields.concat(this.customFields);
                return fields;
            }
        },
        methods: {
            handleSubmit() {
                this.$emit('select', this.fieldValue);
                this.$nextTick(() => {
                    this.modalClose();
                    this.reset();
                });
            },
            reset() {
                this.fallback = '';
                this.selectedField = null;
            },
            modalClose() {
                this.modalOpen = false;
            }
        }
    }
</script>
